import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { CartState } from '@app/store/state/cart.state';
import { SharedModule } from '@app/shared';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { InvitationPublicCLoudCreatePasswordComponent } from './invitation-public-cloud-create-password.component';
import { IkPasswordInputModule, ValidationCheckModule } from '@infomaniak/angular-common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
    declarations: [InvitationPublicCLoudCreatePasswordComponent],
    imports: [
        CommonModule,
        NgxsModule.forFeature([CartState]),
        IkPasswordInputModule,
        SharedModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationCheckModule,
        MatButtonModule
    ],
    exports: [InvitationPublicCLoudCreatePasswordComponent]
})
export class InvitationPublicCloudCreatePasswordModule { }
